export const buildSignInRedirect = (path?: string) => {
  const fallbackPath =
    typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}`
      : "/home";
  const target = path || fallbackPath || "/home";
  return `/sign-in?redirect=${encodeURIComponent(target)}`;
};
